import React, { Children, createContext, useEffect, useState } from 'react'

export const ModalContext = createContext(null)

type Props = {
	children: any
	handler: any
}

export const useModals = () => {
	const [openState, setOpenState] = useState({})
	let tmpOpenState = { ...openState }
	return {
		openState: openState,
		setOpenState: setOpenState,
		open: (id) => {
			tmpOpenState[id] = true
			setOpenState(tmpOpenState)
		},
		close: (id) => {
			tmpOpenState[id] = false
			setOpenState(tmpOpenState)
		},
	}
}

const Modals = (props: Props) => {
	const { children, handler } = props
	const arrayChildren: any = Children.toArray(children)

	useEffect(() => {
		let open = {}
		arrayChildren.map((modal) => {
			let id = modal.props?.modalId ?? modal.type.displayName
			// displayName is not changed on production minification so safe to use
			if (!id) {
				console.error(
					'Modal is missing displayName property! Modal with following props:',
					modal.props
				)
			}
			open[id] = false
		})
		handler.setOpenState(open)
	}, [])

	// only visable
	let visibleChildren = arrayChildren.filter((modal) => {
		let allowed = true
		if (modal.props?.rightsCheck) {
			allowed = modal.props.rightsCheck()
		}
		let id = modal.props?.modalId ?? modal.type.displayName
		return modal.type.displayName && handler.openState[id] && allowed
	})

	// setup if needs closing actions
	const closeModal = (id, onCloseCallback) => {
		handler.close(id)
		if (onCloseCallback) {
			onCloseCallback()
		}
	}

	// add handler
	visibleChildren = visibleChildren.map((modal) => {
		let id = modal.props?.modalId ?? modal.type.displayName
		return React.cloneElement(modal, {
			handler: handler,
			modalId: id,
			onClose: () => closeModal(id, modal?.props?.onClose),
		})
	})

	return (
		<>
			{visibleChildren.map((child, i) => {
				return (
					<ModalContext.Provider
						key={i}
						value={{ modalId: child.props.modalId, handler: handler }}
					>
						{child}
					</ModalContext.Provider>
				)
			})}
		</>
	)
}

export default Modals
